<mat-toolbar class="tw-px-0 tw-h[50px]">
    <div class="tw-flex tw-flex-row tw-w-full tw-justify-between">
        <div id="thread-list-button" class="tw-mr-2">
            <button
                matTooltip="View Previous Conversations"
                (click)="displayThreadMenu.emit()"
                mat-mini-fab
                aria-label="Display Thread List"
            >
                <mat-icon>menu</mat-icon>
            </button>
        </div>

        <div
            id="show-thread-details"
            class="tw-flex tw-items-center tw-gap-2 tw-max-w-[350px]"
        >
            @if (currentChat | async) {
                <div name="chatNameOrIdContainer" class="chatNameOrIdContainer">
                    <!--If the chat name is a string but blank, it doesn't have a name in the Portal Database, 
                    If the chat name is null/undefined it is a newly created chat thread-->
                    @if (displayThreadName) {
                        @if ((currentChat | async)?.threadName === "") {
                            Chat Name Not Found
                        } @else if ((currentChat | async)?.threadName == null) {
                            New Chat Thread
                        } @else {
                            {{ (currentChat | async)?.threadName }}
                        }
                    } @else {
                        {{ (currentChat | async)?.threadId }}
                    }
                </div>
            } @else {
                <ng-template #error>Error Loading Thread ID</ng-template>
            }
        </div>

        <button
            mat-mini-fab
            (click)="openChatDialog()"
            class="tw-place-self-center"
        >
            <mat-icon>open_in_new</mat-icon>
        </button>
    </div>
    <div class="tw-flex-[1,1,auto]"></div>
</mat-toolbar>
